//This file is for application independent commonly used variables and functions

import { message } from "antd";

//Notifiers
export const ErrorMessage = (content) => {
  message.error(content);
}

export const SuccessMessage = (content) => {
  message.success(content);
}

export const InfoMessage = (content) => {
  message.info(content);
}

export const WarnMessage = (content) => {
  message.warning(content);
}

export const User_Roles = {
  Normal_User:"User",
  Super_User:"Super User",
  Client_User:"Client User",
  TimecardFollowup_User:"Timesheet Coordinator"
}

//Util for replacing underscore with space in strings
export const ReplaceUnderscoreWithSpace = (text) => {
  if (!(text === null || text.trim() === "" || text === undefined)) {
    return text.replace("_", " ");
  }
};

//Util for validating whether a string is null, empty and undefined 
export const StringValidations = (text) =>{
  if (text === null || text.trim() === "" || text === undefined) {
    return false;
  }
  else{
    return true;
  }
}

// Get Current Date
export const GetDefaultDate = () => {
  let date = new Date();
  const options = {
    year:"numeric",
    month:"2-digit",
    day:"2-digit"
  };
  let currentDate = date.toLocaleDateString('en-US', options);
  return currentDate;
}